import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Alert
} from "@mui/material";
import { Warning } from "@mui/icons-material";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { toggleBcbsT2GWarningDialog } from "../../../../../app/slices/VerificationModuleSlice";

function BcbsT2GWarningDialog() {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(
    (state) => state.verificationModule.BcbsT2GWarningDialog
  );

  const handleClose = () => {
    dispatch(toggleBcbsT2GWarningDialog());
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Warning color="error" />
        PCP Referral & Facility Authorization Required
      </DialogTitle>

      <DialogContent>
        <Alert severity="error" sx={{ mb: 2 }}>
          <DialogContentText component="div">
            <strong>BCBS T2G Plan Requirement</strong>
            <br />This member's policy begins with "T2G", which requires a PCP
            referral and facility authorization.
          </DialogContentText>
        </Alert>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="contained" color="primary">
          Understood
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export { BcbsT2GWarningDialog };
